// Estado de error reutilizable para queries que fallan (timeout, red, etc.)
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowPathIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface QueryErrorStateProps {
  message?: string;
  onRetry?: () => void;
  compact?: boolean;
}

export function QueryErrorState({
  message = 'Error al cargar los datos. Verifica tu conexión o inténtalo de nuevo.',
  onRetry,
  compact = false,
}: QueryErrorStateProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg text-sm">
        <ExclamationTriangleIcon className="w-5 h-5 text-red-500 flex-shrink-0" />
        <span className="text-red-700 flex-1">{message}</span>
        {onRetry && (
          <Button size="sm" variant="outline" onClick={onRetry} className="flex-shrink-0">
            <ArrowPathIcon className="w-4 h-4 mr-1" />
            Reintentar
          </Button>
        )}
      </div>
    );
  }

  return (
    <Card className="border-red-200">
      <CardContent className="py-12 text-center space-y-4">
        <div className="flex justify-center">
          <div className="bg-red-100 p-4 rounded-full">
            <ExclamationTriangleIcon className="w-8 h-8 text-red-500" />
          </div>
        </div>
        <div>
          <p className="text-gray-700 font-medium">No se pudieron cargar los datos</p>
          <p className="text-sm text-gray-500 mt-1">{message}</p>
        </div>
        {onRetry && (
          <Button variant="outline" onClick={onRetry}>
            <ArrowPathIcon className="w-4 h-4 mr-2" />
            Reintentar
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
